module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/13bd951b42b52db5dd945271b02f98bb.gif";